import login from './login'
import common from './common'
import log from './log'
import inform from './inform'
import preference from './preference'
import personalData from './personalData'
import adhibition from './adhibition'
import account from './account'
import verify from './verify'
import utils from './utils'
import authorization from './authorization'
import todo from './todo'
import zeroTrust from './zeroTrust'
import theme from './theme'

const zh = {
    ...common,
	login: login,
  theme: theme,
    log: log,
    inform: inform,
    preference: preference,
    personalData: personalData,
    adhibition: adhibition,
    account: account,
    verify: verify,
    utils: utils,
    authorization:authorization,
    todo:todo,
    zeroTrust:zeroTrust
}
export default zh
